// 发送测试表单的草稿与校验（docs/04 第 11 节）：号码、sender 与正文的上限与客户 HTTP 接口一致（docs/06 第 2 节）。
import type { TestSendInput, TestTarget } from "@/app/testSend";
import type { Errors } from "@/app/useDraft";

export interface TestSendDraft { target: TestTarget; channel: string; account: string; to: string; sender: string; text: string }

export function testSendDraft(): TestSendDraft {
  return { target: "channel", channel: "", account: "", to: "", sender: "", text: "" };
}

/** 正文上限，按字符计。 */
export const MAX_TEXT = 2000;

export function testSendInput(d: TestSendDraft): { body?: TestSendInput; errors: Errors<TestSendDraft> } {
  const errors: Errors<TestSendDraft> = {};
  if (d.target === "channel" && !d.channel) errors.channel = "选择要测试的通道。";
  if (d.target === "account" && !d.account) errors.account = "选择以哪个账号发送。";
  const to = d.to.trim().replace(/^\+/, "");
  if (!/^\d{7,15}$/.test(to)) errors.to = "7 到 15 位数字，带国家码，不带 +。";
  const sender = d.sender.trim();
  if (!sender || new TextEncoder().encode(sender).length > 20) errors.sender = "必填，不超过 20 个字节（与服务端同一口径）。";
  const chars = [...d.text].length;
  if (chars === 0 || chars > MAX_TEXT) errors.text = `必填，不超过 ${MAX_TEXT} 个字符。`;
  if (Object.keys(errors).length) return { errors };
  const target = d.target === "channel" ? { channel_id: Number(d.channel) } : { account_id: Number(d.account) };
  return { errors, body: { target: d.target, ...target, to, sender, text: d.text } };
}
